import { render, staticRenderFns } from "./modalItemsNeedingAttention.vue?vue&type=template&id=39cf04cf"
import script from "./modalItemsNeedingAttention.vue?vue&type=script&lang=js"
export * from "./modalItemsNeedingAttention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports